// Группа переключателей фильтра

import {h} from 'preact';
import FilterCheckboxesItem from './FilterCheckboxesItem';
import {StateFilterCheckbox} from './Store/State';

/**
 * Component Properties
 */
interface FilterCheckboxesProps
{
	/** Имя формы */
	formName: string;
	/** Имя переключателя */
	baseName: string;
	/** Подпись группы */
	label: string;
	/** Переключатели */
	items: StateFilterCheckbox[];
}

/**
 * Группа переключателей фильтра
 */
function FilterCheckboxes( {formName, baseName, label, items}: FilterCheckboxesProps ): JSX.Element
{
	return (
		<li class={'checkboxes field-' + baseName}>
			<fieldset>
				<legend>{label}</legend>
				<ul>
					{
						items.map(
							( item: StateFilterCheckbox ) => (
								<FilterCheckboxesItem
									formName={formName}
									name={baseName + '[]'}
									{...item}
								/>
							),
						)
					}
				</ul>
			</fieldset>
		</li>
	);
}

/**
 * Module
 */
export {
	FilterCheckboxes as default,
	FilterCheckboxesProps,
};



// WEBPACK FOOTER //
// ./app/Routes/Choose/App/FilterCheckboxes.tsx